import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../design-system/icons.jsx';
export default function ExportButton({ onCSV, onPDF, disabled = false, size = 'sm' }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const itemStyle = (id) => ({
    display: 'flex', alignItems: 'center', gap: 8,
    padding: '8px 14px', width: '100%',
    background: hoveredItem === id ? 'var(--bg-hover)' : 'transparent',
    border: 'none',
    color: hoveredItem === id ? 'var(--text-primary)' : 'var(--text-secondary)',
    fontSize: 'var(--fs-sm)',
    cursor: 'pointer', fontFamily: 'inherit',
    transition: 'background var(--dur-fast), color var(--dur-fast)',
  });

  return (
    <div ref={wrapRef} style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        type="button"
        onClick={() => { if (!disabled) setOpen(o => !o); }}
        disabled={disabled}
        title={t('common.a11y.exportData')}
        className={`btn btn-secondary btn-${size}`}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
      >
        <Icon name="download" size={13} strokeWidth={2} />
        {t('common.export.button')}
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', right: 0,
          background: 'var(--bg-surface)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-md)',
          boxShadow: 'var(--shadow-md)',
          zIndex: 'var(--z-dropdown)',
          minWidth: 170, padding: '4px 0',
        }}>
          {onCSV && (
            <button
              type="button"
              onClick={() => { onCSV(); setOpen(false); }}
              onMouseEnter={() => setHoveredItem('csv')}
              onMouseLeave={() => setHoveredItem(null)}
              style={itemStyle('csv')}
            >
              <Icon name="spreadsheet" size={13} strokeWidth={1.8} />
              {t('common.export.asCsv')}
            </button>
          )}
          {onPDF && (
            <button
              type="button"
              onClick={() => { onPDF(); setOpen(false); }}
              onMouseEnter={() => setHoveredItem('pdf')}
              onMouseLeave={() => setHoveredItem(null)}
              style={itemStyle('pdf')}
            >
              <Icon name="document" size={13} strokeWidth={1.8} />
              {t('common.export.asPdf')}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
